<template>
  <section class="qnabox" :style="{'--chat-headerColor': chat.headerColor, '--chat-mainColor': chat.mainColor, '--chat-bgColor': chat.bgColor, '--chat-pinnedBGColor': chat.pinnedBGColor, '--chat-pinnedNameColor': chat.pinnedNameColor, '--chat-pinnedTextColor': chat.pinnedTextColor, '--chat-outlineColor': chat.outlineColor, '--chat-nameColor': chat.nameColor, '--chat-adminNameColor': chat.adminNameColor,'--chat-adminBoxColor': chat.adminBoxColor, '--chat-nameBoxColor': chat.nameBoxColor, '--chat-boxColor': chat.boxColor, '--chat-textColor': chat.textColor, '--chat-inputTextColor': chat.inputTextColor, '--chat-inputBGColor': chat.inputBGColor, '--chat-inputOutlineColor': chat.sendOutlineColor, '--chat-sendTextColor': chat.sendTextColor, '--chat-sendBGColor': chat.sendBGColor, '--chat-sendOutlineColor': chat.sendOutlineColor, '--chat-messagesOutlineColor': chat.messagesOutlineColor, '--chat-scrollbarBGColor': chat.scrollbarBGColor, '--chat-scrollbarHandleColor': chat.scrollbarHandleColor, '--chat-borderRadius': chat.borderRadius, '--chat-editBtnColor': chat.editBtnColor, '--chat-editBtnBGColor': chat.editBtnBGColor }">
    <div class="header-container">
      <div class="header-icon-and-title">
        <ion-icon class="qna-icon" name="chatbubbles-outline" v-if="!chat.header.startsWith('<')"></ion-icon>
        <div class="qna-title" v-html="chat.header"></div>
      </div>
    </div>
    <div class="qna-questions-container" ref="questionsContainer" @scroll="scrollHandler">
      <div class="qna-question"
        :style="{ opacity: question.checked ? '1' : '0.8', filter: `saturate(${question.checked ? '1' : '0'})` }"
        v-for="(question, k) in questionsComputed" :key="k">
        <span class="qna-question-pinner" v-if="isAdmin || isUser(question.user_id,question.userId)">
          <!-- <i title="Fixar" class="fas fa-thumbtack" @click.prevent="pinQnAQuestion(question, true)" v-if="!question.fixed"></i>
          <i title="Destacar" class="fas fa-bahai" @click.prevent="highlightQnAQuestion(question, false)" v-if="!question.highlight"></i>
          <i title="Retirar destaque" class="fas fa-virus-slash" @click.prevent="pinQnAQuestion(question, false)" v-if="question.highlight"></i> -->
          <i :title="`${question.checked ? 'Esconder pergunta' : 'Mostrar pergunta'}`" class="fas"
            :class="{ 'fa-eye-slash': question.checked, 'fa-eye': !question.checked }"
            @click.prevent="markAnswered(question)" v-if="isAdmin && activityData.property.interactivities.qa.config.useModeration"></i>
          <i title="Deletar" class="fas fa-trash-alt" @click.prevent="deleteQnAQuestion(question)"></i>
        </span>
        <!-- <img :src="question.image" alt class="user-avatar" /> -->
        <p class="qna-question-content" :class="{ 'isHighlighted': question.highlight }">
          <span class="qna-username">{{ question.userName }} <i>{{ dayjs(question.date).format('DD/MM HH: mm')}}</i></span>
          <span class="qna-theme-indicator" v-if="config.useThemes && question.theme">{{question.theme}} </span>
          <span class="qna-text" :class="{'with-line-brake':config.allowLineBreak}"> {{ question.text }}</span>
        </p>
      </div>
    </div>
    <div class="qna-themes-container" v-if="config.useThemes">
      <div class="qna-themes-header" @click="showThemes=!showThemes">
        <span><i class="fas fa-filter"></i> {{currentTheme}}</span>
        <span style="margin-left:auto" @click.stop="showUserQuestionsOnly=!showUserQuestionsOnly">
          <span v-if="showUserQuestionsOnly">Minhas perguntas <i class="fas fa-user"></i></span>
          <span v-else>Todas <i class="fas fa-users"></i></span>
        </span>
      </div>
      <div class="qna-theme" :class="{'picked':currentTheme===theme}" v-for="theme,k in config.themes" :key="k" @click="currentThemeHandler(theme)" v-show="showThemes"><span>{{theme}}</span></div>
    </div>
    <div class="qna-field-container">
      <textarea ref="questionInput" class="qna-question-input" :placeholder="placeholder ? placeholder : 'Perguntar'" :class="{ 'isHighlightedQuestion': isHighlightedQuestion }" type="text" v-model="question" @keypress="checkSend" />
      <!-- <span class="send-question-pinner" :class="{'isHighlightedQuestion':isHighlightedQuestion}" @click.prevent="isHighlightedQuestion=!isHighlightedQuestion" :style="isHighlightedQuestion?{opacity:'1'}:{}" v-if="isAdmin"><i class="fas fa-thumbtack"></i></span> -->
      <button class="qna-send-button" @click="sendQuestion" v-if="chat.enableSendButton">
        <ion-icon style="transform: rotate(45deg)" class="send-button-ionicon" name="paper-plane-outline"></ion-icon>
      </button>
      <div class="emoji-picker-wrapper">
        <emoji-picker @emoji="append" :search="search">
          <div :class="{ 'emoji-invoker-solo': !chat.enableSendButton }" class="emoji-invoker" slot="emoji-invoker"
            slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
            </svg>
          </div>
          <div slot="emoji-picker" slot-scope="{ emojis, insert }">
            <div class="qna-emoji-picker">
              <div class="emoji-picker__search">
                <input type="text" v-model="search" v-focus>
              </div>
              <div>
                <div v-for="(emojiGroup, category) in emojis" :key="category">
                  <h5>{{ category }}</h5>
                  <div class="emojis">
                    <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)"
                      :title="emojiName">{{ emoji }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </emoji-picker>
      </div>
    </div>

    <!-- SCROLL TO LATEST BTN -->
    <button ref="scrollToTopBtn" class="scrollToTopBtn" :style="{bottom: showThemes ? '170px' : '80px'}">
      <ion-icon class="scrollBtn-icon" name="chevron-down-circle-sharp"></ion-icon>
    </button>

  </section>
</template>

<script>
import api from '@/services/api.js';
import EmojiPicker from 'vue-emoji-picker';
import * as dayjs from 'dayjs';

export default {
  name: 'QnABox',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    questions: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disableAutoScroll: {
      type: Boolean,
      default: false
    },
  },
  components: { EmojiPicker },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      isAdmin: false,
      emojiIconFill: 'white',
      qnaQuestions: [],
      question: '',
      input: '',
      search: '',
      isHighlightedQuestion: false,
      dayjs: null,
      scrollAtBottom: true,
      currentTheme: '',
      showThemes: false,
      showUserQuestionsOnly: false,
    };
  },

  computed: {
    questionsComputed() {
      if (this.showUserQuestionsOnly) return this.questionsThemed.filter((q) => q.userId === this.$store.state.user.id);
      else return this.questionsThemed;
    },
    questionsThemed() {
      if (this.config.useThemes && this.currentTheme) return this.qnaQuestions.filter((q) => q.theme === this.currentTheme)
      else return this.qnaQuestions;
    },
  },

  methods: {
    apiGetQnAQuestions() {
      api
        .get(`activity/${this.$route.params.stream}/listQuestions?limit=200`)
        .then(response => {
          const useModeration = this.activityData.property.interactivities.qa.config.useModeration ?? true;
          this.qnaQuestions = response.data.reverse();
          if (!useModeration) {
            this.qnaQuestions = this.qnaQuestions.map(item => {
              item.checked = true;
              return item;
            });
          }
          if (!this.isAdmin && useModeration) this.qnaQuestions = this.qnaQuestions.filter(i => i.checked || i.userId === this.$store.state.user.id);
          this.$nextTick(() => {
            this.scrollToMostRecent();
          });
        })
        .catch(error => console.error('What API call to get user questions?', error));
    },
    isUser(user_id, userId) {
      return this.$store.state.user.id === user_id || this.$store.state.user.id === userId;
    },
    append(emoji) {
      this.question += emoji;
    },
    insert(emoji) {
      this.input += emoji;
    },
    scrollHandler() {
      if (!this.$refs.questionsContainer) return;
      const scrollTop = this.$refs.questionsContainer.scrollTop;
      const scrollHeight = this.$refs.questionsContainer.scrollHeight;
      const clientHeight = this.$refs.questionsContainer.clientHeight;
      if (scrollHeight - clientHeight <= scrollTop) {
        this.scrollAtBottom = true;
        this.$refs.scrollToTopBtn.style.display = 'none';
      } else {
        this.scrollAtBottom = false;
        this.$refs.scrollToTopBtn.style.display = 'block';
      }
    },
    scrollToMostRecent() {
      if (!this.$refs.questionsContainer || this.disableAutoScroll) return;
      this.$refs.questionsContainer.scrollTop = this.$refs.questionsContainer.scrollHeight;
    },
    scrollOnScrollerClick() {
      if (!this.$refs.questionsContainer) return;
      this.$refs.questionsContainer.scrollTop = this.$refs.questionsContainer.scrollHeight;
    },
    checkSend(event) {
      if (event.key == 'Enter' && !event.shiftKey && !event.ctrlKey && !event.altKey) {
        this.sendQuestion();
      }
    },
    sendQuestion() {
      if (this.question != '') {
        // this.$emit('send', {
        //   question: this.question,
        //   theme: this.config.useThemes ? this.currentTheme ? this.currentTheme : this.config.currentTheme : null,
        //   pinned: this.isHighlightedQuestion
        // });

        this.apiSendQuestion({
          question: this.question,
          theme: this.config.useThemes ? this.currentTheme ? this.currentTheme : this.config.currentTheme : null,
          pinned: this.isHighlightedQuestion
        });

        this.question = '';
        this.$refs.questionInput.blur();
      } else return;
    },
    apiSendQuestion({ question, theme, pinned }) {
      if (this.isDragging) return;

      // console.log('question', this.question, this.question.length);
      if (question.length > 0 && question.length <= 3000) {
        let msg = {
          type: 'send-question',
          channel: this.$route.params.stream,
          userId: this.$store.state.user.id,
          name: this.$store.state.user.name,
          text: question,
          theme: this.activityData.property.interactivities.qa.config.useThemes && theme ? theme : null,
          properties: null
        };
        api
          .post(`send-question/${this.$route.params.stream}`, msg)
          .then(response => {
            // msg.type = 'new-question';
            // this.wsClient.send(JSON.stringify(msg));
            this.question = '';
            this.showQuestionOverlay = false;
            this.apiGetQnAQuestions();
            api.post(`sessionAction/`, {
              action: 'Question Send',
              properties: JSON.stringify(msg),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          })
          .catch(err => {
            console.error('error sending question', err);
          });
      } else if (question.length > 3000) {
        alert('Pergunta muito longa. Máximo 3 mil caracteres');
      }
    },
    markAnswered(question) {
      question.checked = !question.checked;
      const OPEN = 'question-open';
      const ANSWERED = 'question-answered';
      const REMOVED = 'question-removed';
      api
        .put(`activity/${this.$route.params.stream}/updateQuestion`, {
          qna_id: question.id,
          highlight: question.checked,
          tags: ANSWERED,
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteQnAQuestion(question) {
      if (confirm('Remover pergunta?')) {
        if (question.id) {
          // console.log('deleteQnAQuestion', question.id);
          api
            .delete(`activity/${this.$route.params.stream}/deleteQuestion`, { data: { qna_id: question.id } })
            .then(response => {
              // console.log('deleteQnAQuestion RESPONSE: ', { response });
              this.apiGetQnAQuestions();
              api.post(`sessionAction/`, {
                action: 'Question Delete',
                properties: JSON.stringify(question),
                userid: this.$store.state.user.id,
                sessionid: this.$store.state.user.token,
                event_id: this.$store.state.eventId,
              });
            })
            .catch(err => {
              console.error('error deleting chat', err);
            });
        }
      }
    },
    unpinQnAQuestion(question) {
      this.$emit('unpinQnAQuestion', { question: question, pinned: false });
    },
    updatePosition() {
      this.$nextTick(() => {
        this.$refs.questionsContainer.scrollTop = this.$refs.questionsContainer.scrollHeight;
      });
    },
    updateCurrentTheme(theme) {
      this.currentTheme = theme;
    },
    currentThemeHandler(theme) {
      if (this.currentTheme === theme) this.currentTheme = '';
      else this.currentTheme = theme
    },
  },
  insert(emoji) {
    this.question += emoji;
  },
  beforeMount() {
    this.dayjs = dayjs;
    this.chat = this.$store.state.template.chat;
    this.emojiIconFill = this.chat.inputTextColor;
    this.isAdmin = this.$store.state.user.role === '1819bd5e-7b46-11ea-bc55-0242ac130003' || this.$store.state.user.role === '1819bea8-7b46-11ea-bc55-0242ac130003'; //operators and admins
    if (this.config.currentTheme) this.currentTheme = this.config.currentTheme;
    this.apiGetQnAQuestions();
  },
  mounted() {
    this.$refs.scrollToTopBtn.addEventListener('click', this.scrollOnScrollerClick);
    setTimeout(() => {
      this.scrollToMostRecent();
    }, 1300);
  },
};
</script>

<style lang="scss">
.qnabox {
  position: relative;
  padding: 4px 13px 10px;
  height: 100%;
  width: 100%;
  // margin-left: 20px;
  background: var(--chat-mainColor) !important;
  border: 1px solid var(--chat-outlineColor) !important;
  border-radius: var(--chat-borderRadius);

  display: flex;
  flex-direction: column;

  @include media("<=tablet") {
    margin-left: 0;
    padding-left: 2%;
    padding-right: 2%;
  }

  @include media("<=phone") {
    margin: 0;
  }

  .header-container {
    position: relative;
    // height: 48px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    color: var(--chat-headerColor);

    .header-icon-and-title {
      position: relative;
      width: 100%;
      opacity: 0;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      .qna-icon {
        position: relative;
        color: var(--chat-headerColor);
        font-size: 1.8rem;
        margin-right: 8px;
      }

      .qna-title {
        position: relative;
        text-align: center;
        color: var(--chat-headerColor);
        // width: 100%;
        height: 48px;
        font-size: 1.2rem;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
      }
    }
  }

  .qna-themes-container {
    position: relative;
    padding: 6px 0 0;
    // max-height: 100px;
    // overflow-y: auto;

    display: flex;
    flex-wrap: wrap;
    // flex-direction: column;
    // align-items: center;
    // align-content: stretch;
    gap: 8px;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }

    .qna-themes-header {
      position: sticky;
      width: 100%;
      height: 20px;

      display: flex;
      align-items: center;
      font-size: 0.8rem;
      color: var(--chat-headerColor);
      opacity: 0.6;
      cursor: pointer;

      i {
        padding-top: 4px;
        font-size: 0.8rem;
      }
    }

    .qna-theme {
      position: relative;
      background: #555;
      padding: 4px;
      border-radius: 4px;
      // text-align: center;
      font-size: 0.8rem;
      cursor: pointer;
    }

    .picked {
      background: var(--chat-pinnedBGColor);
    }
  }

  .qna-questions-container {
    position: relative;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--chat-bgColor);
    border: 1px solid var(--chat-messagesOutlineColor);
    border-radius: var(--chat-borderRadius);
    padding: 2%;
    padding-top: 4%;
    padding-left: 0;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: var(--chat-scrollbarBGColor) !important;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--chat-scrollbarHandleColor) !important;
    }
  }

  .scrollToTopBtn {
    width: 34px;
    height: 34px;
    position: absolute;
    bottom: 170px;
    right: 46%;
    z-index: 100;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: none;
    color: var(--chat-scrollbarHandleColor);
    background: var(--chat-scrollbarBGColor);
  }

  .scrollBtn-icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    transform: scale(1.3);
    // font-size: 2.7rem;
  }

  .qna-question {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 4px;

    // background-color: red;
    span:nth-child(2) {
      margin-left: 2px;
    }
  }

  .qna-question:hover > .qna-question-pinner {
    opacity: 1;
  }

  .qna-question-pinner {
    position: absolute;
    // top: 0;
    right: 4px;
    padding: 0 4px;
    opacity: 0;
    background: var(--chat-editBtnBGColor);
    color: var(--chat-editBtnColor);
    border-radius: 4px;
    z-index: 1;
    i {
      font-size: 0.98rem;
    }
  }

  .send-question-pinner {
    position: absolute;
    top: -15px;
    left: -15px;
    width: 30px;
    height: 30px;
    z-index: 1;
    padding: 3px;
    background: #666;
    border-radius: 40px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.4);
    opacity: 0;
    transition: all 0.4s ease-in-out;

    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 0.92rem;
    }

    &:hover {
      opacity: 1;
    }
  }

  .qna-question-input:focus + .send-question-pinner {
    opacity: 1;
  }

  .qna-question-content {
    position: relative;
    width: 100%;
    // margin-right: 2px;
    margin-left: 8px;
    font-size: 0.9rem;
    letter-spacing: 0.023rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    line-height: 1.5rem;
    background-color: var(--chat-boxColor);
    border-radius: var(--chat-borderRadius);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .qna-username {
      // font-size: 1.6vh;
      // margin: -6px 0 0 -6px;
      padding: 2px 5px;
      width: 100%;
      font-size: 0.9rem;
      font-weight: bold;
      color: var(--chat-nameColor);
      background-color: var(--chat-nameBoxColor);
      opacity: 0.9;
      // border-radius: 6px;
      display: flex;
      align-items: center;

      i {
        margin-left: auto;
        font-size: 0.6rem;
        color: var(--chat-nameColor);
        opacity: 0.7;

        @media (max-width: 1200px) {
          display: none;
        }
      }
    }

    .qna-text {
      position: relative;
      padding: 2px 8px 4px;
      color: var(--chat-textColor);
    }

    .with-line-brake {
      width: 100%;
      white-space: pre-line;
    }

    .qna-theme-indicator {
      position: relative;
      padding: 0 8px 0 4px;
      width: 100%;
      height: 20px;
      font-size: 0.75rem;
      font-style: italic;
      color: var(--chat-textColor);
      opacity: 0.8;
    }
  }

  .isHighlighted {
    background: var(--chat-pinnedBGColor);
    width: 100%;
    padding: 3%;
    font-size: 1.1rem;
  }

  .isHighlightedQuestion {
    background: var(--chat-pinnedBGColor);
    background-color: var(--chat-pinnedBGColor) !important;
  }

  .qna-field-container {
    position: relative;
    width: 100%;
    height: 50px;
    background-color: transparent;
    padding: 12px 0px 12px 6px;
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .qna-question-input {
    position: relative;
    padding: 10px 8px 4px;
    flex-grow: 1;
    height: 42px;
    border: none;
    background-color: transparent;
    border-radius: var(--chat-borderRadius);
    outline: none;
    color: var(--chat-inputTextColor);
    background-color: var(--chat-inputBGColor);
    border: 1px solid var(--chat-inputOutlineColor);
    border-radius: var(--chat-borderRadius);
    resize: none;

    &:focus {
      outline: none;
    }
  }

  .qna-send-button {
    cursor: pointer;
    position: relative;
    flex-grow: 0;
    border: none;
    outline: none;
    width: 42px;
    height: 42px;
    background-color: var(--chat-sendBGColor);
    border: 1px solid var(--chat-sendOutlineColor);
    border-radius: var(--chat-borderRadius);
    color: var(--chat-inputTextColor);
    margin: 0 2px 0 4px;
  }

  .send-button-ionicon {
    color: var(--chat-sendTextColor);
    opacity: 0.5;
    font-size: 1.68rem;
    margin-top: 4px;
    margin-right: 5px;

    &:hover {
      opacity: 0.8;
    }
  }

  // EMOJI PICKER
  .emoji-picker-wrapper {
    position: absolute;
    bottom: 37px;
    width: 100%;
    display: inline-block;
    z-index: 0;
  }

  .emoji-invoker {
    position: absolute;
    // top: 0.5rem;
    right: 60px;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 1;
    opacity: 0.5;

    &:hover {
      opacity: 0.9;
    }
  }

  .emoji-invoker-solo {
    right: 16px;
  }

  .qna-emoji-picker {
    top: -336px;
    position: absolute;
    z-index: 1;
    border: 1px solid #ffffff80;
    width: 100%;
    height: 320px;
    overflow: auto;
    overflow-x: hidden;
    padding: 1rem;
    box-sizing: border-box;
    border-radius: var(--chat-borderRadius);
    // background: var(--chat-bgColor);
    background: #555;
    padding-right: 8px;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: var(--chat-scrollbarBGColor);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--chat-scrollbarHandleColor);
    }
  }

  .qna-emoji-picker h5 {
    margin: 0;
    margin-top: 10px;
    color: var(--chat-textColor);
    // color: black;
    text-transform: uppercase;
    font-size: 1rem;
    cursor: default;
  }

  .regular-input {
    padding: 0.5rem 1rem;
    border-radius: 3px;
    border: 1px solid #ccc;
    width: 20rem;
    height: 12rem;
    outline: none;
  }

  .regular-input:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .emoji-invoker:hover {
    transform: scale(1.1);
  }

  .emoji-invoker > svg {
    fill: var(--chat-inputTextColor);
    opacity: 0.7;
  }

  .emoji-picker__search {
    position: relative;
    display: flex;
    height: 24px;
  }

  .emoji-picker__search > input {
    flex: 1;
    border-radius: 12px;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    outline: none;
    width: 90%;
  }

  .emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .emoji-picker .emojis:after {
    content: "";
    flex: auto;
  }

  .emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
  }

  .emoji-picker .emojis span:hover {
    background: #ececec;
    cursor: pointer;
  }

  .emojis {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

    span {
      padding: 4px;
      cursor: pointer;
    }
  }
}
</style>